import { updateInitialConfig, updateModifiedConfig } from "../../checksumStore";

export const updateDetailsviewChecksum = (blockData, isInit = false) => {
  let storeConfig = { ...blockData };
  if (isInit) {
    updateInitialConfig(storeConfig);
  } else {
    updateModifiedConfig(storeConfig);
  }
  return storeConfig;
};
